module.exports = __webpack_public_path__ + "static/media/afiche-coromoto-369-anos-small.04b3ba93.jpg";